var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "OBJECTS",
    viewBox: "0 0 600.28 355.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2 {\n                fill: url(#linear-gradient);\n            }\n\n            .cls-3 {\n                fill: url(#linear-gradient-2);\n            }\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 171.87,
    y1: 178.34,
    x2: 600.28,
    y2: 178.34,
    gradientUnits: "userSpaceOnUse",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06a27a",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ae4bc",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 436.35,
    y1: -170.81,
    x2: 557.85,
    y2: 411.16,
    xlinkHref: "#linear-gradient",
    fill: "#000000"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.58.68s-30.76,69,65,38.36,80.92,11.67,68,33c-14,23.13-32.68,37.21-31,60.08,2.19,30,46.17,31.11,83.06,50.19,89.06,46.08-11.55,7.7-45.48,29.74s-13.23,38.45,33.71,36.77c101.38-3.64,67.76,30.66,50.82,46.19s-14,51,65.77,27,49.79,34,49.79,34h84V.68Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M506.15.68S391.5-5.3,371.09,70c-22.24,82.09,48.89,120.68,73,101.84s25.22-44.45-12.34-61.35-33.78-69,48.34-56S571.74,172,512.24,197s-45,54.44,19,85.72,29,73.23,29,73.23h40V.68Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImg1);
export default __webpack_public_path__ + "static/media/banner_img1.04ffb5d4fdf6f8680057322bbb1c7be1.svg";
export { ForwardRef as ReactComponent };